export default "__VITE_ASSET__391c78f3__"